import { PersonActions } from './personActions';
import { PersonActionTypes } from './personActionTypes'
import { initialPersonState, IPersonState } from './personState';

export const personReducer = (state = initialPersonState, action: PersonActions): IPersonState => {
    switch (action.type) {
        case PersonActionTypes.SET_CURRENT_PROFILE:
        {
            return {
                ...state,
                currentUser: action.payload
            };
        }
        default: {
            return state;
        }
    }
}